export enum CustomDensityOption {
  Default = 'default',
  Mobile = 'mobile'
}